export enum Features {
  REPORT_CATCH_YEAR = "REPORT_CATCH_YEAR",
  REPORT_CATCHES = "REPORT_CATCHES",
  GUEST_CARD = "GUEST_CARD",
  INSPECTION = "INSPECTION",
  MEMBER_WORK = "MEMBER_WORK",
  MEMBER_WORK_EXTENDED = "MEMBER_WORK_EXTENDED",
  APPOINTMENT = "APPOINTMENT",
}
